import React from 'react';
import ManageDomain from '../Domain/ManageDomain';

const PartyDetailProvider = (props: any) => {
    const { params } = props.match;
    return (
        <React.Fragment>
            <ManageDomain partyId={params?.id} />
        </React.Fragment>
    );
}

export default PartyDetailProvider;